/**
 * @generated SignedSource<<0f48bcae7334e0568e23822480367e7a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VitalSignFragment$data = {
  readonly bloodPressureDiastolic: number | null;
  readonly bloodPressureSystolic: number | null;
  readonly bloodSugarMgDl: number | null;
  readonly bloodSugarMmol: number | null;
  readonly bodyTemperature: number | null;
  readonly breathRate: number | null;
  readonly cReactiveProtein: number | null;
  readonly glasgowComaScaleEye: number | null;
  readonly glasgowComaScaleMotor: number | null;
  readonly glasgowComaScaleVerbal: number | null;
  readonly heartRate: number | null;
  readonly oxygenSaturation: number | null;
  readonly strepATestPositive: boolean | null;
  readonly visualAnalogPainScale: number | null;
  readonly " $fragmentType": "VitalSignFragment";
};
export type VitalSignFragment$key = {
  readonly " $data"?: VitalSignFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VitalSignFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VitalSignFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bloodPressureDiastolic",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bloodPressureSystolic",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bloodSugarMgDl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bloodSugarMmol",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bodyTemperature",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "breathRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cReactiveProtein",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "glasgowComaScaleEye",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "glasgowComaScaleMotor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "glasgowComaScaleVerbal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "heartRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oxygenSaturation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "strepATestPositive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visualAnalogPainScale",
      "storageKey": null
    }
  ],
  "type": "VitalSign",
  "abstractKey": null
};

(node as any).hash = "79ccd7df425eb579b7850ed330d3cd1a";

export default node;
